// extracted by mini-css-extract-plugin
export default {"container":"StudentsInfo_container__UREYU","studentContainer":"StudentsInfo_studentContainer__WFc9V","photo":"StudentsInfo_photo__nFwa9","fullName":"StudentsInfo_fullName__lsk1a"};